import { FC } from 'react'
import {
  IArticle,
  IPodcastEpisode,
  IStory,
  IWebinar,
  isArticle,
  isPodcast,
  isStory,
  isWebinar,
} from '@estercare/ester-shared'
import { PreviewGuard } from './PreviewGuard'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { getOptions } from './richText/options'
import { CollectionCard } from './CollectionCard'
import { useTranslation } from 'react-i18next'

interface Props {
  item: IArticle | IPodcastEpisode | IStory | IWebinar
}

export const CollectionItem: FC<Props> = ({ item }) => {
  const { t } = useTranslation()

  if (isArticle(item)) {
    const { slug, title, abstract, primaryImage } = item.fields
    const label = t('common.content.article')
    const completeSlug = `/portal/resource-center/articles/${slug}`

    if (!title || !abstract || !primaryImage) {
      return <PreviewGuard />
    }
    return (
      <CollectionCard
        horizontal
        slug={completeSlug}
        title={title}
        abstract={abstract}
        label={label}
        image={{ url: primaryImage.fields.file.url, description: primaryImage.fields.description }}
      />
    )
  }
  if (isPodcast(item)) {
    const { slug, title, episodeNumber, featuredImage, description } = item.fields
    const label = `${t('common.content.episode')} ${episodeNumber}`
    const completeSlug = `/portal/resource-center/podcasts/${slug}`
    if (!title || !description || !featuredImage || !episodeNumber) return <PreviewGuard />
    return (
      <CollectionCard
        slug={completeSlug}
        title={title}
        abstract={description && documentToReactComponents(description, getOptions(true))}
        label={label}
        image={{ url: featuredImage.fields.file.url, description: featuredImage.fields.description }}
        episodeNumber={episodeNumber}
      />
    )
  }
  if (isStory(item)) {
    return <PreviewGuard />
  }
  if (isWebinar(item)) {
    const { slug, title, description, featuredImage } = item.fields
    const label = `${t('common.content.webinar')}`
    const completeSlug = `/portal/resource-center/webinars/${slug}`

    if (!title || !description || !featuredImage) return <PreviewGuard />
    return (
      <CollectionCard
        slug={completeSlug}
        title={title}
        horizontal
        abstract={description && documentToReactComponents(description, getOptions(true))}
        label={label}
        image={{ url: featuredImage.fields.file.url, description: featuredImage.fields.description }}
      />
    )
  }
  return <PreviewGuard />
}
